if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"amd_legacy","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(010|433|673|800)|2(022|197|826)|3(232|493|592|60|656|776)|4(004|073|121|853)|5(04|143|506|711|818)|6(423|569|598|929|95)|7(3|456|581|796|804|954)|8(36|43|862)|9(068|199|443|788|802))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"amd-modern":[{"alias":"amd-modern","name":"","entry":"","shareScope":"default","externalType":"unknown"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}